<app-alert-messages *ngIf="bResponseAlert" [resMessage]="resMessage"></app-alert-messages>

<div class="modal-header d-flex justify-content-between">
    <div>
        <h4 class="modal-title">{{file?.name}}</h4>
    </div>
    <div class="d-flex align-items-center" *ngIf="promptsList?.length > 0">
        <h4 class="modal-title prompt-border py-1 px-2">{{activeDisplayName}}</h4>
        <span class="prompt-list" (click)="openVersionModal(versionModal)">
            <i class="fa-solid fa-list font-14"></i>
        </span>
    </div>

    <div class="d-flex">
        <button class="btn btn-primary me-2 btn-sm" (click)="savePrompts('save')">Save</button>
        <button class="btn btn-primary me-2 btn-sm" (click)="savePrompts('saveNew')">Save as New</button>
        <button type="button" class="btn-close  mt-0" aria-label="Close" (click)="onClose()"></button>
    </div>

</div>

<div class="left-part main-sidebar" *ngIf="this.checkeditorSpecs?.content && !this.checkeditorSpecs?.editorSpecs">
    <div style="height: calc(100vh - 60px)">
        <div class="position-relative parent-codemirror code-toolbar">
            <ngx-codemirror #codemirror id="codemirror" name="html" [options]="codeMirrorOptions" [(ngModel)]="json"
                [autoFocus]="true">
            </ngx-codemirror>
        </div>
    </div>
</div>

<div class="left-part main-sidebar" *ngIf="this.checkeditorSpecs?.content && this.checkeditorSpecs?.editorSpecs">
    <div style="height: calc(100vh - 60px)">
        <as-split unit="pixel" [gutterSize]="3" direction="horizontal">
            <as-split-area [size]="250" [minSize]="250" [maxSize]="700">
                <aside>
                    <div class="sidebar">
                        <div
                            class="d-flex justify-content-between query-header border-bottom flex-wrap align-items-center">
                            <h6 class="mb-0 ms-2 heading">Structured Prompts</h6>
                        </div>

                        <div class="align-left">
                            <div class="border-bottom"></div>
                            <div *ngIf="!bLoading && structuredPrompt?.length > 0">
                                <div #treeViewContainer class="list-height">
                                    <div *ngFor="let item of structuredPrompt; index as i" class="folder-item">
                                        <div>
                                            <ul class="border-bottom">
                                                <div>
                                                    <div class="d-flex prompt-key align-items-center py-2"
                                                        [class.selected]="selectedPromptRowIndex === i"
                                                        (click)="selectPromptItem(item,i,false,false)">
                                                        <!-- Expand/Collapse Icon -->
                                                        <i class="fa carret-icon"
                                                            [ngClass]="item.expand ? 'fa-caret-down fa-solid' : 'fa-caret-right fa-solid'">
                                                        </i>
                                                        <!-- Main item text -->
                                                        <span
                                                            class="cursor-pointer d-flex align-items-center gap-10 mx-1"
                                                            (click)="selectPromptItem(item,i,false,false)">
                                                            <span class="d-inline-block sub-heading"
                                                                style="max-width: 160px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                                {{ item?.key }}
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <!-- Nested Items (Recursive) -->
                                                    <div *ngIf="item.expand && item.children" class="ps-2">
                                                        <ng-container
                                                            *ngFor="let child of item.children; index as childIndex">
                                                            <div class="d-flex prompt-key align-items-center py-2 position-relative"
                                                                [class.selected]="selectedPromptRowIndex === (i + '-' + childIndex)"
                                                                (mouseenter)="hoveredChild = { parentIndex: i, childIndex: childIndex }"
                                                                (mouseleave)="hoveredChild = null"
                                                                (click)="handleClick(child, i + '-' + childIndex)">
                                                                <!-- Caret icon -->
                                                                <i class="fa carret-icon"
                                                                    [ngClass]="child.expand ? 'fa-caret-down fa-solid' : 'fa-caret-right fa-solid'">
                                                                </i>
                                                                <!-- Text (no separate click anymore) -->
                                                                <span
                                                                    class="cursor-pointer d-flex align-items-center gap-10 mx-1">
                                                                    <span class="d-inline-block sub-heading"
                                                                        style="max-width: 140px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                                        {{ child?.key }}
                                                                    </span>
                                                                </span>
                                                                <i *ngIf="hoveredChild?.parentIndex === i && hoveredChild?.childIndex === childIndex"
                                                                    class="fa fa-trash fa-solid font-12 text-danger position-absolute"
                                                                    style="right: 30px; cursor: pointer;"
                                                                    (click)="removechild($event,item,i,childIndex)">
                                                                </i>
                                                                <!-- Plus icon on hover -->
                                                                <i *ngIf="hoveredChild?.parentIndex === i && hoveredChild?.childIndex === childIndex"
                                                                    class="fa fa-plus fa-solid position-absolute"
                                                                    style="right: 10px; cursor: pointer;"
                                                                    (click)="addDuplicateChild(item, child,childIndex,$event)">
                                                                </i>
                                                            </div>
                                                            <!-- Grandchildren (recursive) -->
                                                            <div *ngIf="child.expand && child.children" class="ps-2">
                                                                <ng-container
                                                                    *ngFor="let grandChild of child.children; index as grandChildIndex">
                                                                    <!-- Repeat same logic here if needed (can expand recursion if you want) -->
                                                                </ng-container>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!bLoading && structuredPrompt?.length == 0"
                                class="notes-list sidebar-tree-view mt-2">
                                <ul class="d-flex align-items-center justify-content-center">
                                    <li>
                                        <span class="text-black-0 heading"> No Prompts Found!</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </aside>
            </as-split-area>
            <as-split-area>
                <div>
                    <div class="html-head border-bottom" *ngIf="!updateChildKey">
                        <h6 class="mt-2 ms-2">{{selectedItem?.key}}</h6>
                    </div>
                    <div class="html-head border-bottom d-flex align-items-center py-2 px-2" *ngIf="updateChildKey">
                        <ng-container *ngIf="!isEditingKey; else editTemplate">
                          <h6 class="mb-0 me-2">{{ selectedItem?.key }}</h6>
                          <i class="bi bi-pencil-square text-primary cursor-pointer" (click)="startEditingKey()"></i>
                        </ng-container>
                      
                        <ng-template #editTemplate>
                          <input
                            type="text"
                            class="form-control form-control-sm me-2"
                            [(ngModel)]="editedKey"
                            (keyup.enter)="saveEditedKey()"
                            style="width: 220px !important;"
                          />
                          <span class="tick-border"><i class="bi bi-check-lg text-success cursor-pointer" (click)="saveEditedKey()"></i></span>
                        </ng-template>
                      </div>
                    <div class="overFlow">
                        <div [ngClass]="formData?.editor === 'json' ? '' : 'structured-editor'">
                            <!-- Textarea -->
                            <textarea #resizableTextarea *ngIf="formData?.editor === 'textarea'" [rows]="formData.rows || 3"
                                [(ngModel)]="formData.value" class="form-control mb-2 resizeable-textarea">
                            </textarea>
                            <!-- String List -->
                            <div *ngIf="formData?.editor === 'stringList'">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <label for="text" >{{formData?.key}}</label>
                                    <button class="btn btn-primary btn-sm" (click)="addItem()">Add Item</button>
                                </div>
                                <div class="string-list-item position-relative" *ngFor="let item of formData?.value; let i = index; trackBy: trackByIndex">
                                    <textarea #resizableTextarea class="form-control mb-2 resizeable-textarea" [(ngModel)]="formData?.value[i]"></textarea>
                                    <button class="remove-button" (click)="removeItem(i)"><i class="fa-solid fa-times"></i></button>
                                </div>                              
                            </div>
                            <!-- Object List -->
                            <div *ngIf="formData?.editor === 'objectList'">
                                <div class="sub-nodes-card text-center py-3 border shadow-sm" *ngIf="parentItem">
                                    <h6>Please select one of the sub nodes to proceed</h6>
                                    <div class="separator-with-text">or</div>
                                    <button class="btn btn-primary add-subnode-btn mt-2" (click)="addsubNode()">Add Sub Node</button>
                                </div>
                                <!-- Loop over each object in children -->
                                <div *ngFor="let obj of formData?.children; let i = index" class="object-group">
                                    <!-- If the object has fields -->
                                    <div *ngIf="obj?.fields && !parentItem">
                                        <div *ngFor="let field of obj?.fields" class="field-group">
                                            <label for="text">{{field?.name}}</label>
                                            <textarea #resizableTextarea class="form-control mb-2 resizeable-textarea" [(ngModel)]="field.value"
                                                [rows]="field.rows"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Text -->
                            <div  *ngIf="formData?.editor === 'text'">
                                <label for="text">{{formData?.key}}</label>
                                <input type="text" class="form-control resizeable-textarea" [(ngModel)]="formData.value" />
                            </div>
                            <!-- Field Set -->
                            <div class="form-container" *ngIf="formData?.editor === 'fieldSet'">
                                <div *ngFor="let field of formData?.fields">
                                    <label for="text">{{field?.name}}</label>
                                    <textarea #resizableTextarea class="form-control mb-3 resizeable-textarea" [(ngModel)]="field.value"
                                        [rows]="field.rows"></textarea>
                                </div>
                            </div>
                            <!-- Json -->
                            <div class="position-relative parent-codemirror code-toolbar"
                            *ngIf="formData?.editor === 'json'">
                                <ngx-codemirror #codemirror id="codemirror" name="html" [options]="codeMirrorOptions"
                                    [(ngModel)]="formData.value" [autoFocus]="true">
                                </ngx-codemirror>
                            </div>
                        </div>
                    </div>
                </div>
            </as-split-area>
        </as-split>
    </div>
</div>

<ng-template #versionModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Prompts</h4>
    </div>
    <div class="modal-body">
        <div class="versionModalHeight ">
            <div class="border-bottom"></div>
            <div *ngIf="!bLoading && promptsList?.length > 0">
                <div #treeViewContainer class="prompts-height">
                    <div *ngFor="let item of promptsList; index as i" [id]="item.id" class="folder-item">
                        <div>
                            <ul class="border-bottom px-0 mb-0 cursor-pointer">
                                <div>
                                    <div class="d-flex prompt-key prompt-items justify-content-between align-items-center py-2"
                                        [class.selected]="selectedRowIndex == i" (click)="getPromptData(item, i);"
                                        (mouseenter)="hoveredRowIndex = i" (mouseleave)="hoveredRowIndex = -1">

                                        <span class="d-inline-block sub-heading px-2"
                                            [attr.title]="(item?.displayName ? item?.displayName : item?.name + '(' + item?.version + ')')">
                                            {{ item?.displayName ? item?.displayName : item?.name + '(' + item?.version
                                            + ')' }}
                                        </span>

                                        <span *ngIf="selectedRowIndex == i || hoveredRowIndex == i"
                                            class="badge font-11 font-400 rounded-0 me-2"
                                            [ngClass]="(item.active == 1 || item.active == true) ? 'bg-primary border' : 'bg-secondary border'"
                                            (click)="activatePrompt(item); $event.stopPropagation()"
                                            style="cursor: pointer;">
                                            {{(item.active == 1 || item.active == true) ? 'Activated':'Activate'}}
                                        </span>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!bLoading && promptsList?.length == 0" class="notes-list sidebar-tree-view mt-2">
                <ul class="d-flex align-items-center justify-content-center">
                    <li>
                        <span class="text-black-0 heading"> No Prompts Found!</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-secondary btn-sm" (click)="modal.dismiss()">Close</button>
    </div>
</ng-template>